import { logger } from "./logger";
import { FormikValues, FormikErrors } from "formik";

interface MultiStepFormParams {
  validateForm: (values: FormikValues) => Promise<any>;
  values: FormikValues;
  stepIndex: number;
  setErrors: (errors: FormikErrors<FormikValues>) => void;
  steps: number;
  stepsInfo: string[];
  setSteps: React.Dispatch<React.SetStateAction<number>>;
  saveHandler: (values: FormikValues) => void;
}

export const formikMultiStepHandler = ({
  validateForm,
  values,
  stepIndex,
  setErrors,
  steps,
  stepsInfo,
  setSteps,
  saveHandler,
}: MultiStepFormParams) => {
  
  validateForm(values).then((res) => {
    if (Object.entries(res).length === 0) {
      // validation success
      const lastStepIndex = stepsInfo?.length - 1;
      if (stepIndex <= -1) {
        setSteps(0);
        return;
      } else if (steps === lastStepIndex && stepIndex > lastStepIndex) {
        saveHandler(values);
        return;
      } else if (stepIndex <= lastStepIndex) {
        setSteps((prev) => stepIndex);
        return;
      }
    } else {
      // validation failed
      logger.error(res);
      if (setErrors) {
        setErrors(res);
      }
    }
  });
};
